"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transCoordSys = exports.calcPointRotation = exports.GCJ022WGS84 = exports.WGS842GCJ02 = exports.GCJ022BD09 = exports.BD092GCJ02 = void 0;
var PI = 3.1415926535897932384626;
var x_PI = (PI * 3000.0) / 180.0;
var a = 6378245.0;
var ee = 0.00669342162296594323;
/**
 * 纬度转换
 * @param lng
 * @param lat
 */
var transformlat = function (lng, lat) {
    var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
    ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
    ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0;
    ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0;
    return ret;
};
/**
 * 经度转换
 * @param lng
 * @param lat
 */
var transformlng = function (lng, lat) {
    var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
    ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0;
    ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0;
    return ret;
};
/**
 * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
 * 即 百度 转 谷歌、高德
 * @param point 坐标点
 * @returns {*[]}
 */
exports.BD092GCJ02 = function (point) {
    var longitude = point.longitude, latitude = point.latitude;
    var lng = Number(longitude);
    var lat = Number(latitude);
    if (!lng || !lat)
        return {};
    var x = lng - 0.0065;
    var y = lat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_PI);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_PI);
    return {
        longitude: String(z * Math.cos(theta)),
        latitude: String(z * Math.sin(theta))
    };
};
/**
 * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
 * 即谷歌、高德 转 百度
 * @param point 坐标点
 * @returns {*[]}
 */
exports.GCJ022BD09 = function (point) {
    var longitude = point.longitude, latitude = point.latitude;
    var lng = Number(longitude);
    var lat = Number(latitude);
    if (!lng || !lat)
        return {};
    var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
    var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
    return {
        longitude: String(z * Math.cos(theta) + 0.0065),
        latitude: String(z * Math.sin(theta) + 0.006)
    };
};
/**
 * WGS84转GCj02
 * @param point 坐标点
 * @returns {*[]}
 */
exports.WGS842GCJ02 = function (point) {
    var longitude = point.longitude, latitude = point.latitude;
    var lng = Number(longitude);
    var lat = Number(latitude);
    if (!lng || !lat)
        return {};
    var dlat = transformlat(lng - 105.0, lat - 35.0);
    var dlng = transformlng(lng - 105.0, lat - 35.0);
    var radlat = (lat / 180.0) * PI;
    var magic = Math.sin(radlat);
    magic = 1 - ee * magic * magic;
    var sqrtmagic = Math.sqrt(magic);
    dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
    dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
    return {
        longitude: String(lng + dlng),
        latitude: String(lat + dlat)
    };
};
/**
 * GCJ02 转换为 WGS84
 * @param point 坐标点
 * @returns {*[]}
 */
exports.GCJ022WGS84 = function (point) {
    var longitude = point.longitude, latitude = point.latitude;
    var lng = Number(longitude);
    var lat = Number(latitude);
    if (!lng || !lat)
        return {};
    var dlat = transformlat(lng - 105.0, lat - 35.0);
    var dlng = transformlng(lng - 105.0, lat - 35.0);
    var radlat = (lat / 180.0) * PI;
    var magic = Math.sin(radlat);
    magic = 1 - ee * magic * magic;
    var sqrtmagic = Math.sqrt(magic);
    dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
    dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
    return {
        longitude: String(lng + dlng),
        latitude: String(lat + dlat)
    };
};
/**
 * 计算地图上两点之间旋转角度
 * @param current 起点位置（平面坐标）
 * @param target 终点位置（平面坐标）
 */
exports.calcPointRotation = function (current, target) {
    var deg = 0;
    if (target.x !== current.x) {
        var tan = (target.y - current.y) / (target.x - current.x);
        var atan = Math.atan(tan);
        deg = atan * (360 / (2 * Math.PI));
        deg = target.x < current.x ? -deg + 90 : -deg - 90;
        return -deg;
    }
    var disy = target.y - current.y;
    var bias = 0;
    bias = disy > 0 ? -1 : 1;
    return -bias * 90 + 90;
};
var tansWays = {
    BD09_GCJ02: [exports.BD092GCJ02],
    GCJ02_BD09: [exports.GCJ022BD09],
    GCJ02_WGS84: [exports.GCJ022WGS84],
    WGS84_GCJ02: [exports.WGS842GCJ02],
    WGS84_BD09: [exports.WGS842GCJ02, exports.GCJ022BD09],
    BD09_WGS84: [exports.BD092GCJ02, exports.GCJ022WGS84] // 百度转WGS84坐标系
};
/**
 * 转换点的坐标系
 * @param origSys 原本的坐标系 默认WGS84
 * @param transSys 需要转换的坐标系 默认 BD09
 * @param point 点
 */
exports.transCoordSys = function (origSys, transSys, point) {
    if (origSys === void 0) { origSys = 'WGS84'; }
    if (transSys === void 0) { transSys = 'BD09'; }
    var transName = origSys.toUpperCase() + "_" + transSys.toUpperCase();
    var ways = tansWays[transName];
    if (!ways)
        return point;
    var transPoint = point;
    ways.forEach(function (way) {
        transPoint = way(transPoint);
    });
    return transPoint;
};
exports.default = (function (UIP) {
    UIP.checkModule('interface', 'geo', 'utils');
    UIP.interface.geo.utils = {
        BD092GCJ02: exports.BD092GCJ02,
        transCoordSys: exports.transCoordSys,
        calcPointRotation: exports.calcPointRotation,
        GCJ022WGS84: exports.GCJ022WGS84,
        GCJ022BD09: exports.GCJ022BD09,
        WGS842GCJ02: exports.WGS842GCJ02
    };
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-geo/dist/utils/index.js
// module id = H0To
// module chunks = 1